<section>
  <div class="header">
    <h2>
      <strong>Write Message</strong>
    </h2>

  </div>
  <div class="body">
    <h3>To {{toUser}}</h3>

    <div class="row">
      <div class="col-8 col-sm-12 col-xs-12">

      </div>
    </div>
    <ckeditor [editor]="Editor" (change)="onChange($event)"></ckeditor>
  </div>
  <br />
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
      <button class="msr-3" mat-raised-button color="primary" (click)="sendMessage()">Submit</button>
      <button type="button" mat-button (click)="cancel()">Cancel</button>
    </div>
  </div>
</section>